// month-boundary date helpers for the scorecard date pickers. scorecard data
// is month-granular (records are pre-calculated per YYYY-MM), so the pickers
// only offer first-of-month "from" dates and last-of-month "to" dates (plus
// today, within the current month). extracted from
// driver_manager_compare.vue so the dashboard toolbar and the comparison
// share one implementation.
import moment from 'moment'

export function buildFirstOfMonthDates(minD, maxD) {
  const out = []
  let m = minD.clone().startOf('month')
  const lastMonthStart = maxD.clone().startOf('month')
  while (m.isSameOrBefore(lastMonthStart, 'month')) {
    const first = m.clone().date(1)
    if (first.isSameOrBefore(maxD, 'day') && first.isSameOrAfter(minD, 'day')) {
      out.push(first.clone())
    }
    m.add(1, 'month')
  }
  return out
}

export function buildLastOfMonthOrTodayDates(minD, maxD) {
  const out = []
  const today = moment().startOf('day')
  let m = minD.clone().startOf('month')
  const lastMonthStart = maxD.clone().startOf('month')
  while (m.isSameOrBefore(lastMonthStart, 'month')) {
    const last = m.clone().endOf('month').startOf('day')
    if (last.isSameOrAfter(minD, 'day') && last.isSameOrBefore(maxD, 'day')) {
      out.push(last.clone())
    }
    if (m.isSame(today, 'month') && today.isBefore(last, 'day')) {
      out.push(today.clone())
    }
    m.add(1, 'month')
  }
  return out
}

// The default reporting window shared by the scorecard dashboard's pickers
// and the Coaching Portal's flagged-drivers panel: the last six complete
// months, holding everything back one month until the ~7th while the
// previous month's pre-calc lands. The two surfaces compute flags over the
// SAME window on purpose — they must agree on who is flagged (see
// utils/scorecard_flags.js); a portal reading a different period than the
// dashboard's Flagged tab would disagree with it every month.
export function defaultScorecardRange(now = moment()) {
  const settled = now.date() >= 7
  return {
    from: now.clone().subtract(settled ? 6 : 7, 'months').startOf('month'),
    to: now.clone().subtract(settled ? 1 : 2, 'months').endOf('month'),
  }
}
